module.exports = __webpack_public_path__ + "static/media/ghayth-abidi.c28d3089.png";